const Backbone = require('backbone');
const PricedOptionModel = require('app/models/store/client/product/pricedoption');
const PricedOptionsCollection = Backbone.Collection.extend({
	model: PricedOptionModel,

	initialize: function() {
		this.on('change:selected', this.pricedOptionsSelected, this);
	},

	/**
	 * getSelection - Returns all priced options that are active
	 * @return {Array} - Priced Option models
	 */
	getSelection: function() {
		return this.where({
			selected: true
		});
	},

	/**
	 * [_pricedOptionsSelected description]
	 * @private
	 */
	pricedOptionsSelected: function() {
		this.trigger('options:changed', this);
	}
});

module.exports = PricedOptionsCollection;
